import { createContext } from '@lit-labs/context';

const stepWizardContext = createContext(Symbol('tenable-step-wizard-context'));

export default stepWizardContext;
